// extracted by mini-css-extract-plugin
export default {"section":"About_section__T6HoR","about":"About_about__eLKSI","image":"About_image__quYAj","text":"About_text__llmHa"};